import { client, clientHC } from '.';
const url = '/todolist';
//FETCH_TO_DO_LIST

// Action Creators
export function fetchToDoList(loggedUser){
  return dispatch => {
    dispatch({
      type: 'FETCH_TO_DO_LIST',
      payload: client.post(url, {loggedUser: loggedUser})
    })
  }
}

// Action Creators
export function fetchToDoHCList(loggedUser){
    return dispatch => {
      dispatch({
        type: 'FETCH_TO_DO_HC_LIST',
        payload: clientHC.post(url, {loggedUser: loggedUser})
      })
    }
}

//Function to turn on and off the sound alarms
export function soundsOnChange(){
    return dispatch => {
        dispatch({
            type: 'SOUNDS_ON_STATE_CHANGE',
            payload: 1
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/to-do-actions.js